import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

export const isSearchUserSelectDisabled = (state: ApplicationState) => {
    const billTo = getCurrentBillToState(state);
    const level = billTo.value?.budgetEnforcementLevel;
    return billTo.isLoading === false && (level === "Customer" || level === "ShipTo");
};

export const isShipToAddressSelectDisabled = (state: ApplicationState) => {
    const billTo = getCurrentBillToState(state);
    const level = billTo.value?.budgetEnforcementLevel;
    return billTo.isLoading === false && (level === "Customer" || level === "User");
};
